import React, { useEffect, useState } from "react";
import { CustomButton } from "../../../../components/customButton/CustomButton";
import { CustomInput } from "../../../../components/customInput/CustomInput";
import {
  BG_COLOR,
  LIGHT_GREY_BG_MODAL,
} from "../../../../resources/colorsManager";
import UpiDetails from "./UpiDetails";

function AddCustomerIndividual({ onClose }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [step, setStep] = useState(0);
  const [disabled, setDisabled] = useState(true);
  const inputStyle = {
    backgroundColor: BG_COLOR,
    alignSelf: "center",
    marginBottom: 15,
    height: 50,
    width: "100%",
    boxShadow: "none",
    // minWidth: 280,
    // maxWidth: 400,
  };

  useEffect(() => {
    if (mobileNumber.length === 10 && firstName !== "" && lastName !== "") {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [firstName, lastName, mobileNumber]);
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      {step === 0 ? (
        <div
          style={{
            marginTop: 20,
          }}
        >
          <div>
            <p
              style={{
                fontSize: 14,
                color: "#888888",
                fontFamily: "Roboto",
              }}
            >
              Customer Basic Information
            </p>
          </div>
          <CustomInput
            value={firstName}
            onChange={(val) => {
              setFirstName(val);
            }}
            type="input"
            validator="name"
            inputStyles={{
              ...inputStyle,
            }}
            placeholder="First Name"
          />

          <CustomInput
            value={lastName}
            onChange={(val) => {
              setLastName(val);
            }}
            type="input"
            validator="name"
            inputStyles={{
              ...inputStyle,
            }}
            placeholder="Last Name"
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
              margin: 0,
              backgroundColor: BG_COLOR,
              margin: 0,
              height: 45,
              borderRadius: 5,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "100%",
                justifyContent: "center",
                width: 80,
                borderRight: "1px solid grey",
              }}
            >
              <p
                style={{
                  padding: 0,
                  margin: 0,
                  fontSize: 15,
                }}
              >
                +91
              </p>
            </div>
            <CustomInput
              value={mobileNumber}
              onChange={(val) => {
                setMobileNumber(val);
              }}
              type="input"
              validator="mobile"
              inputStyles={{
                ...inputStyle,
                backgroundColor: "transparent",
                border: "none",
                margin: 0,
              }}
              placeholder="Customer Mobile Number"
              maxLength={10}
            />
          </div>

          <CustomButton
            title="Next"
            styles={{
              width: "100%",
              marginTop: 40,
              border: "none",
              height: 45,
              borderRadius: 4,
            }}
            disabled={disabled}
            onClick={() => {
              setStep(1);
            }}
          />
        </div>
      ) : (
        <>
          <UpiDetails
            data={[
              {
                firstName,
                lastName,
                mobileNumber,
              },
            ]}
            onClose={onClose}
          />
        </>
      )}
    </div>
  );
}

export default AddCustomerIndividual;
